module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGl2ZWxsb18xIiBkYXRhLW5hbWU9IkxpdmVsbG8gMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTAgNTAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmZmZmO308L3N0eWxlPjwvZGVmcz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNDkgNC45NiA0NS4wNCAxIDI1IDIxLjA0IDQuOTYgMSAxIDQuOTYgMjEuMDQgMjUgMSA0NS4wNCA0Ljk2IDQ5IDI1IDI4Ljk2IDQ1LjA0IDQ5IDQ5IDQ1LjA0IDI4Ljk2IDI1IDQ5IDQuOTYiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/svg/white/icone_close.svg
// module id = eXv2
// module chunks = 9